module.exports = __webpack_public_path__ + "img/gzfx.3b20ceca.svg";